/* Restore only the selected manually played native video, after user action. */
(function () {
  'use strict';
  function hydrate(video) {
    if (!video || !video.hasAttribute('data-neo-video-deferred')) return false;
    var mp4 = video.getAttribute('data-neo-mp4');
    if (mp4) {
      var connection = navigator.connection;
      var small = connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''));
      var fallback = small ? video.getAttribute('data-neo-small') || mp4 : mp4;
      var hls = !small && video.getAttribute('data-neo-hls');
      var nativeHls = hls && video.canPlayType('application/vnd.apple.mpegurl');
      var source = video.querySelector('source') || document.createElement('source');
      if (!source.parentNode) video.appendChild(source);
      video.querySelectorAll('source').forEach(function (other) { if (other !== source) other.remove(); });
      source.src = nativeHls ? hls : fallback;
      source.type = nativeHls ? 'application/vnd.apple.mpegurl' : 'video/mp4';
      source.removeAttribute('data-neo-src');
      if (nativeHls) {
        var switched = false;
        function useFallback() {
          if (switched) return;
          switched = true;
          source.src = fallback;
          source.type = 'video/mp4';
          video.load();
          video.play().then(function () {
            var wrap = video.closest('.neo-community__video-wrap');
            if (wrap) wrap.classList.add('is-playing');
          }).catch(function () {});
        }
        video.addEventListener('error', useFallback, {once:true});
        source.addEventListener('error', useFallback, {once:true});
      }
    } else {
      video.querySelectorAll('source[data-neo-src]').forEach(function (source) {
        source.setAttribute('src', source.getAttribute('data-neo-src'));
        source.removeAttribute('data-neo-src');
      });
    }
    video.removeAttribute('data-neo-video-deferred');
    video.load();
    return true;
  }
  document.addEventListener('click', function (event) {
    var target = event.target.closest('video[data-neo-video-deferred], .neo-community__play, .js-product-gallery-video-placeholder, .js-video-start-button, .js-video-placeholder, [data-js-video-play]');
    if (!target) return;
    var wrapper = target.closest('.neo-community__video-wrap, .js-video-wrapper, .zoom-slider__slide-target, .video__container, .video');
    if (target.matches('.js-video-start-button, .js-video-placeholder') && wrapper) {
      wrapper.querySelectorAll('video[data-neo-video-deferred]').forEach(function (video) {
        var device = video.getAttribute('data-device');
        if (!device || device === (window.innerWidth < 768 ? 'mobile' : 'desktop')) hydrate(video);
      });
      return;
    }
    var video = target.matches('video') ? target : wrapper && wrapper.querySelector('video[data-neo-video-deferred]');
    if (!hydrate(video)) return;
    if (target.matches('video')) video.play().catch(function () {});
  }, true);
  window.neotesHydrateVideo = hydrate;
})();
